<template lang="pug">
  .employee-list-wrapper
    template(v-if="podeEditarEmpregado")
      h2 {{ id ? `editar`: 'novo' }} {{ $ws('employee') }}
    template(v-else)
      h2 cadastro do {{ $ws('employee') }}

    Validate.name(useState="employee/details/name")
      PTextField(label="nome" name="name" v-focus :copyicon="Boolean(id)" :disabled="!podeEditarEmpregado")

    PTextField(label="código" useState="employee/details/code" name="code" :copyicon="Boolean(id)" type="text" :disabled="!podeEditarEmpregado")

    Validate(useState="employee/details/phoneclockPassword" :minLength="4" onlyNumbers)
      PTextField(label="PIN para registro de ponto" name="phoneclockPassword" :copyicon="Boolean(id)" :disabled="!podeEditarEmpregado")

    Validate(useState="employee/details/closingDate" :min="1" :max="28")
      PTextField(label="dia de ínicio da folha" name="closingDate" type="number" :disabled="!podeEditarEmpregado")

    Validate.company(useState="employee/details/company")
      PSelect(
        labelItem="name",
        required
        :title="$ws('company')",
        :allowEmpty="false"
        useCommon="companies/onlyActive"
       :disabled="!podeEditarEmpregado"
      )

    Validate.employer(useState="employee/details/employer")
      PSelect(
        labelItem="name",
        :title="$ws('employer')",
        :allowEmpty="false"
        useCommon="employers"
       :disabled="!podeEditarEmpregado"
      )

    Validate.customRules(useState="employee/details/customRules")
      PSelect(
        labelItem="name",
        :allowEmpty="false"
        :title="$ws('customRules')",
        useCommon="customRules"
       :disabled="!podeEditarEmpregado"
      )

    PSelect.whbRule(
      v-if="useWHB"
      labelItem="name",
      required
      title="regra de banco de horas",
      useState="employee/details/whbRules",
      :allowEmpty="false"
      noSelectedOption="Sem Regra de Banco de Horas"
      :loadDataFunction="fetchWhbRules"
      :disabled="!podeEditarEmpregado"
    )

    Validate.admissionDate(useState="employee/details/admission")
      PDatePicker(label="data de admissão" required name="admission" :disabled="!podeEditarEmpregado")

    RoutineHandler.routine-handler.fill(useState="employee/details/routineInfo" :disabled="!podeEditarEmpregado")

    .timelogs-register
      h3 registro de pontos e apontamentos

      PCheckbox(v-for="f in ptsRegisterConfigs" :disabled="!podeEditarEmpregado"
      :customVmodel="changeChecksTimelogs(f.field)" :label="f.text" :key="f.field" v-uiv-tooltip="f.tooltip" v-if="f.show")

    .beneficios-register
      h3 registro de benefícios

      PCheckbox(label="possui vale refeição?" useState="employee/details/hasVr" :disabled="!podeEditarEmpregado")
      PCheckbox(label="possui vale transporte?" useState="employee/details/hasVt" :disabled="!podeEditarEmpregado")

    Accordion.campos-opcionais.fill-n-gap(:startOpen="false")
      template(slot="heading")
        span.fs-19(style="text-align: center;") campos opcionais

      template
        .fields

          PTextField(:disabled="!podeEditarEmpregado" :copyicon="Boolean(id)" label="email" useState="employee/details/email" name="email" placeholder="exemplo@gmail.com")

          PTextField(:disabled="!podeEditarEmpregado" :copyicon="Boolean(id)" label="telefone celular" useState="employee/details/cellPhone" name="cellPhone" placeholder="(__) _____-____"
          v-mask="['(##) #####-####', '(##) ####-####']")

          PTextField(:disabled="!podeEditarEmpregado" :copyicon="Boolean(id)" label="telefone residencial" useState="employee/details/phone" name="phone" placeholder="(__) ____-____"
          v-mask="'(##) ####-####'")

          PTextField(:disabled="!podeEditarEmpregado" :copyicon="Boolean(id)" label="rg" useState="employee/details/rg" name="rg" v-mask="'##.###.###-#'" placeholder="99.999.999-9")

          PTextField(:disabled="!podeEditarEmpregado" :copyicon="Boolean(id)" label="cpf" useState="employee/details/cpf" name="cpf" v-mask="'###.###.###-##'" placeholder="999.999.999-99")

          PTextField(:disabled="!podeEditarEmpregado" :copyicon="Boolean(id)" label="ctps" useState="employee/details/ctps" name="ctps" palceholder="123456")

          PTextField(:disabled="!podeEditarEmpregado" :copyicon="Boolean(id)" label="pis" useState="employee/details/pis" name="pis" v-mask="'###.######.##-#'" placeholder="999.999999.99-9")

          PTextField(:disabled="!podeEditarEmpregado" :copyicon="Boolean(id)" label="departamento" useState="employee/details/department" name="department")

          PTextField(:disabled="!podeEditarEmpregado" :copyicon="Boolean(id)" label="função" useState="employee/details/funct" name="funct")

    .custom-fields
      CustomFields(useState="employee/details/customFields" key="custom" :disabled="!podeEditarEmpregado") campos customizáveis

      CustomFields(useState="employee/details/customFieldsFolha" key="custom-folha" :disabled="!podeEditarEmpregado") campos customizáveis da folha

    .button
      PButton(v-if="podeEditarEmpregado" color="success" size="lg" @click="save" :loading="saving") {{ id ? 'salvar' : `criar novo ${$ws('employee')}` }}

</template>

<script>
import RoutineHandler from './RoutineHandler'
import CustomFields from './CustomFields'
import { mapState } from 'vuex'
import { useValidationsMixin } from 'src/common/validations'
import { setAmplitudeEvent } from 'src/amplitudeUtils'

export default {
  name: 'EmployeeList',
  props: {
    id: {type: String, required: false}
  },
  mixins: [useValidationsMixin({deepCheck: true})],
  created () {
    this.$store.commit('employee/details/resetState')
    if (this.id) {
      this.$store.dispatch('employee/details/loadEmployee', this.id)
    }
  },
  components: {CustomFields, RoutineHandler},
  data () {
    return {
      saving: false,
      ptsRegisterConfigs: [
        {text: 'gravar ponto com voz no aplicativo (android)', field: 'allowAppVoice', show: true},
        {text: 'gravar ponto com foto no aplicativo (dispositivos móveis)', field: 'allowAppPhoto', show: true},
        {text: 'mostrar jornada no aplicativo (dispositivos móveis)', field: 'allowAppShowDayJourney', show: true},
        {text: 'mostrar feedback no aplicativo (android)', field: 'allowAppFeedback', show: true},
        {
          text: 'permitir selecionar o local de trabalho que o ponto será registrado (android)',
          field: 'canSelectCompany',
          tooltip: 'Se o dispositivo estiver cadastrado para apenas um local de trabalho, esse local será automaticamente selecionado.',
          show: true
        },
        {text: 'ativar reconhecimento facial (android)', field: 'recognizeFace', show: true},
        {text: 'gravar ponto com voz no pontotel web (computador)', field: 'allowWebVoice', show: true},
        {text: 'ativar dupla confirmação de registro de ponto (computador)', field: 'doubleCheckWeb', show: true},
        {text: 'ativar ponto sequencial', field: 'allowPunchSerial', show: true},
        {text: 'ativar sobreaviso', field: 'hasOnCall', show: this.$store.state.userInfo.compMan.hasOnCall},
        {text: 'registra ponto em qualquer local de trabalho (android)', field: 'phoneclockAll', show: true},
        {text: 'registrar horário de pausa automaticamente', field: 'autoPauseFill', show: true}
      ]
    }
  },
  computed: {
    ...mapState('employee/details', ['loading']),
    useWHB () {
      return this.$store.state.userInfo.compMan.hasWhbank
    },
    podeEditarEmpregado () {
      return this.$hasPermission({module: 'compemployee', action: 'post'})
    }
  },
  methods: {
    async fetchWhbRules () {
      const items = await this.$API.whbRules.get()
      return items.data.success
    },
    changeChecksTimelogs (field) {
      return {
        set: (value) => {
          this.$store.commit('employee/details/changeChecksTimelogs', {field, value})
        },
        get: () => {
          return this.$store.state.employee.details[field]
        }
      }
    },
    async save () {
      if (!this.isAllValid()) {
        this.displayAllErrors()
        return
      }
      this.saving = true

      try {
        await this.$store.dispatch('employee/details/save')

        setAmplitudeEvent('salva funcionario', {})

        this.$router.push('/employee/list')
      } catch (e) {
        console.error(e)
        this.$swal({
          type: 'error',
          text: e.data?.error ? e.data.error : `Não foi possível salvar o ${this.$ws('employee')}`
        })
      }
      this.saving = false
    }
  }
}
</script>

<style scoped lang="scss">
$grid-gaps: 5px;

@mixin grid-columns {
  display: grid;
  grid-template-columns: minmax(0, 0.45fr) minmax(0, 0.45fr) minmax(0, 0.33fr) minmax(0, 0.33fr) minmax(0, 0.33fr);
  grid-column-gap: $grid-gaps;
}

.employee-list-wrapper {
  padding-bottom: 100px;
  margin-bottom: 50px;
  grid-row-gap: 10px;

  @include grid-columns;

  .name {
    grid-column: 1/3;
  }

  h2 {
    text-align: center;
    grid-column: 1/6;
  }

  .company{
    grid-column: 1/3;
  }

  .employer{
    grid-column: 3/6;
  }

  .customRules{
    grid-column: 1/3;
  }

  .admissionDate{
    grid-auto-flow: columns;
    margin-top: 4px;
  }

  .whbRule{
    grid-column: 3/5;
  }

  .routine-handler {
    @include grid-columns
  }

  .campos-opcionais {
    grid-column: 1/6;

    .fields {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      grid-column-gap: 30px;
    }
  }

  .timelogs-register {
    display: grid;
    margin-top: 20px;
    grid-column: 1/6;
    grid-template-columns: 1fr 0.5fr;

    label {
      width: fit-content;
    }

    h3 {
      grid-column: 1/3;
    }
  }

  .beneficios-register {
    display: grid;
    grid-column: 1/3;
    margin-top: 20px;
    margin-bottom: 20px;
    grid-template-columns: auto auto;
    h3 {
      grid-column: 1/3;
    }
  }
  .fill {
    grid-column: 1/6;
  }

  .fill-n-gap, .custom-fields {
    grid-column: 1/6;
    margin-bottom: 20px !important;
  }

  .custom-fields {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-column-gap: $grid-gaps;
  }

  .button {
    grid-column: 1/6;
    justify-self: end;
  }
}
</style>
